import { rootApi } from '../rootApi';

export const faultClientDefinitionsApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getFaultClientDefinitions: builder.query({
            query: (params) => {
                // Base parameters
                const queryParams = {
                    PageNumber: params.PageNumber !== undefined ? params.PageNumber : 0,
                    PageSize: params.PageSize || 10,
                    isActive: params.isActive !== undefined ? params.isActive : 1
                };

                // Only add IsActive if it has a value
                if (params.IsActive !== undefined && params.IsActive !== null) {
                    queryParams.IsActive = params.IsActive;
                }

                // Only add ShortName if it has a value
                if (params.FaultType) {
                    queryParams.FaultType = params.FaultType;
                }

                // Only add FullName if it has a value
                if (params.ProductGroup) {
                    queryParams.ProductGroup = params.ProductGroup;
                }

                // Only add ContractStartDate if it has a value
                if (params.StartDate) {
                    queryParams.StartDate = params.StartDate;
                }

                // Only add ContractEndDate if it has a value
                if (params.EndDate) {
                    queryParams.EndDate = params.EndDate;
                }

                return {
                    url: 'v1/faultclientdefinitions/getlist',
                    method: 'POST',
                    body: queryParams,
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
            },
            transformResponse: (response) => {

                // Check if response has the expected structure with data property
                if (response && typeof response === 'object') {
                    // New structure: { data: { items: [...], totalCount: number } }
                    if (response.data && response.data.items && Array.isArray(response.data.items)) {
                        return {
                            items: response.data.items,
                            totalCount: response.data.totalCount
                        };
                    }

                    // Old structure: { data: [...] }
                    if (response.data && Array.isArray(response.data)) {
                        return {
                            items: response.data,
                            totalCount: response.data.length
                        };
                    }

                    // If response itself is an array, return it directly
                    if (Array.isArray(response)) {
                        return {
                            items: response,
                            totalCount: response.length
                        };
                    }
                }

                // Fallback: return empty array if structure doesn't match
                console.warn('⚠️ Response structure not as expected, returning empty array');
                return {
                    items: [],
                    totalCount: 0
                };
            },
            // Keep track of API state for debugging
            onQueryStarted: async (arg, { queryFulfilled }) => {
                try {
                    const result = await queryFulfilled;
                } catch (error) {
                    console.error('❌ getFaultClientDefinitions query failed:', error);
                }
            },
            providesTags: ['FaultClientDefinitions']
        }),

        createFaultClientDefinition: builder.mutation({
            query: (data) => ({
                url: 'v1/faultclientdefinitions/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['FaultClientDefinitions']
        }),

        updateFaultClientDefinition: builder.mutation({
            query: (data) => ({
                url: 'v1/faultclientdefinitions/update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['FaultClientDefinitions'],
            async onQueryStarted(updatedData, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;

                    // Güncelleme başarılıysa, aynı id ile getById tekrar çağrılır
                    dispatch(
                        faultClientDefinitionsApi.endpoints.getFaultClientDefinitionById.initiate({
                            id: updatedData.id,
                            status: updatedData.status, // opsiyonel, ihtiyacınıza göre gönderin
                            pageSize: 10,
                            pageNumber: 1
                        })
                    );
                } catch (err) {
                    console.error('Update failed or getById fetch failed', err);
                }
            }
        }),

        deleteFaultClientDefinition: builder.mutation({
            query: (id) => ({
                url: 'v1/faultclientdefinitions/delete',
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: ['FaultClientDefinitions']
        }),

        getFaultClientDefinitionById: builder.query({
            query: ({ id, status, pageSize = 10, pageNumber = 1 }) => ({
                url: `v1/faultclientdefinitions/getbyid`,
                method: 'GET',
                params: {
                    id,
                    status,
                    pageSize,
                    pageNumber
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && response.data.length > 0) {
                    return response.data[0];
                }
                return null;
            }
        })
    })
});

export const { useGetFaultClientDefinitionsQuery, useCreateFaultClientDefinitionMutation, useUpdateFaultClientDefinitionMutation, useDeleteFaultClientDefinitionMutation, useGetFaultClientDefinitionByIdQuery } = faultClientDefinitionsApi;
